<template>
  <div>
    <!-- <custom-table :items="items" :headers="headers" :loading="loading">
      <template slot="actions" slot-scope="{ item }">
        <slot name="actions" v-bind:item="item"></slot>
      </template>
    </custom-table> -->
    <v-card class="elevation-0">
      <v-card-title>
        <span v-if="showHeader">Citizenship</span>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          label="Search Here"
          class="my-0 py-0"
        ></v-text-field>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :items="items"
          :headers="headers"
          :search="search"
          :footer-props="footerProps"
          :loading="loading"
        >
          <template v-slot:item.actions="{ item }">
            <slot name="actions" v-bind:item="item"></slot>
          </template>
          <template v-slot:item.dutiesResponsibilitiesDesc="{ item }">
            <span v-html="item.dutiesResponsibilitiesDesc">{{
              item.dutiesResponsibilitiesDesc
            }}</span>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import CustomTable from "../../../../../components/CustomTable";
const API_ENDPOINT = "/api/dutiesRes";
export default {
  props: {
    showHeader: {
      default: false,
      type: Boolean,
    },
  },
  components: {
    CustomTable,
  },
  data: () => ({
    items: [],
    headers: [
      {
        text: "",
        value: "actions",
        sortable: false,
      },
      {
        text: "Code",
        value: "dutiesResponsibilitiesCode",
        sortable: true,
      },
      {
        text: "Description",
        value: "dutiesResponsibilitiesDesc",
        sortable: true,
        html: true,
      },
    ],
    loading: false,
    search: "",
    footerProps: {
      rowsPerPageItems: [20, 50],
    },
  }),
  methods: {
    getAll() {
      this.loading = true;
      this.$axios
        .get(`${API_ENDPOINT}`)
        .then(({ data }) => {
          this.items = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    //this.getAll();
  },
  mounted() {
    this.getAll();
  },
};
</script>
